<template>
<div class="chapter">
<div class="inner_page">
<h4 class="h4"><a id="sec12"></a>C Is for Cher</h4>
<p class="poem">Culture miniature and clad as Cleopatra, she descends<br/>A set of semicircular steps<br/>Tiled in a geometric mosaic pattern</p>
<p class="poem">And there she finds the answer: everything<br/>Changes depending on whether<br/>You’re up or down. Behind her,</p>
<p class="poem">A high-relief rectangle proscenium;<br/>Beside her, whatever intrigued her last.<br/>An unofficial fan leaps feverishly into action. At that,</p>
<p class="poem">She seems to multiply. History will be filled<br/>With the shower of dots that will become her.<br/>At that, she becomes. It’s complex.</p>
<p class="poem">Through the glass she sees a pair of dazzling slippers.<br/>At dinner her drink was called a Vladimir,<br/>Hers was the plate that contained Washington oysters.</p>
<p class="poem">There she held a fork. There she was on a stage<br/>Of discourse. Of course. Mickey Mouse comes over<br/>And stops to stare. Cher is dressed in a long gold dress.</p>
<p class="poem">The sequins form stripes. “If I could turn back time.”<br/>She’s singing. And Mickey in his red pants is acting<br/>Like the goodwill minister to an enraptured world.</p>
<p class="poem"><a id="page_27"></a>Mickey thinks. He turns the corner.<br/>To the gift shop: ever open.<br/>He buys retractable mother-of-pearl opera glasses</p>
<p class="poem">As a present. Yes, it’s over. The present.<br/>In which you discovered forward-thinking thought.</p>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// chapter1_g.vue?2c6a98d3